import { render } from "./PageItem.vue?vue&type=template&id=7e9b8b5c"
import script from "./PageItem.vue?vue&type=script&lang=js"
export * from "./PageItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiPaper/Components/PageItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e9b8b5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e9b8b5c', __exports__)) {
    api.reload('7e9b8b5c', __exports__)
  }
  
  module.hot.accept("./PageItem.vue?vue&type=template&id=7e9b8b5c", () => {
    api.rerender('7e9b8b5c', render)
  })

}


export default __exports__